import { render, staticRenderFns } from "./ButtonCounterDeprecated.vue?vue&type=template&id=db3175ec&scoped=true&"
import script from "./ButtonCounterDeprecated.vue?vue&type=script&lang=js&"
export * from "./ButtonCounterDeprecated.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCounterDeprecated.vue?vue&type=style&index=0&id=db3175ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3175ec",
  null
  
)

export default component.exports